<template>
  <div>
    <router-view />
    <loading :is-active="loadingStore.isActive" :text="loadingStore.text"
      :background-color="loadingStore.backgroundColor" />
  </div>
</template>

<script setup>
  import {
    useLoadingStore
  } from './store/loadingstore'
  import loading from './views/model/loading.vue'
  const loadingStore = useLoadingStore();
</script>
<style lang="scss" scoped>
</style>
